import Link from "@amzn/meridian/link";
import Text from "@amzn/meridian/text";
import React from "react";

import { layoutDescriptionTextStyle } from "../styles/Style";

interface LayoutDescriptionProps {
    content: string;
    faqLink?: string;
}

const LayoutDescription: React.FC<LayoutDescriptionProps> = ({ content, faqLink }) => {
  return (
    <Text data-testid="layoutdescription-content" tag="span">
      {content}
      {faqLink && <Link target="_blank" href={faqLink} data-testid="layoutdescription-faq-link" type="secondary">
        <Text data-testid="layoutdescription-faq-text" tag="span" className={layoutDescriptionTextStyle} type="b200">
                    &ensp;FAQs&ensp;
        </Text>
      </Link>}
    </Text>
  );
};

export default LayoutDescription;